import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import UserLevelPoints from '@/components/UserLevelPoints.vue'
  import Search from '@/components/Search.vue'
  import ToggleSwitch from '@/components/common/ToggleSwitch.vue'

  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useEditor from '@/composables/useEditor'
  import { useRoute } from 'vue-router/composables'

  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'
  import { EditorModule } from '@/store/modules/editor'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'UserControls',
  emits: ['toggle-user-dropdown'],
  setup(__props) {

  const route = useRoute()
  const { defaultUserIcon, allBookmarks } = useIcons()
  const { isKnowledgeCheckCompany, showCompanyOnboardingPopupDetails, showReTriggerOnboardingPopup, hasValidUser } =
    useCommonMixin()
  const { isDesktopDevice, isLargeDesktop } = useBreakpoint()
  const { onEditorPages, inEditorMode } = useEditor(route)

  

  const hoveringBookmark = ref(false)

  const isEditable = computed(() => {
    return onEditorPages.value && CourseModule.course?.isEditable
  })

  const initials = computed((): string => {
    return UserModule.initials || ''
  })

  const toggleEditMode = (value: boolean) => {
    EditorModule.setEditMode(value)
  }

return { __sfc: true,route, defaultUserIcon, allBookmarks, isKnowledgeCheckCompany, showCompanyOnboardingPopupDetails, showReTriggerOnboardingPopup, hasValidUser, isDesktopDevice, isLargeDesktop, onEditorPages, inEditorMode, hoveringBookmark, isEditable, initials, toggleEditMode, computed, ref, SVGRenderer, UserLevelPoints, Search, ToggleSwitch, useIcons, useCommonMixin, useBreakpoint, useEditor, useRoute, UserModule, CourseModule, EditorModule }
}

})